<template>
	<div class="app-admin layout-component-main">
		<div class="breadcrumbs">
			<slot name="breadcrumbs"/>
		</div>
		<div class="header">
			<slot name="header"/>
		</div>
		<div class="body">
			<error-box v-if="error" :error="error"/>
			<slot name="body"/>
			<button-loading v-show="!finished" :loading="loading" @click.native="loader" ref="button" class="btn-primary btn-round btn-loading">Get More</button-loading>
		</div>
	</div>
</template>

<script>
export default {
	props: [
		'loading',
		'loader',
		'finished',
		'error'
	],
	data () {
		return {
			observer: null
		}
	},
	methods: {
		handleIntersect (entry) {
			if (entry[0].isIntersecting && !this.loading) {
				this.loader()
			}
		},
		createObserver () {
			const options = {
				threshold: 1
			}
			this.observer = new IntersectionObserver(this.handleIntersect, options)
			this.observer.observe(this.$refs.button.$el)
		}
	},
	mounted () {
		this.createObserver()
	}
}
</script>



// WEBPACK FOOTER //
// src/components/admin/LayoutAdminAutoLoading.vue